<template>
    <rkm-form
        ref="Form"
        show-legend
    >
        <CidadaoQuestionarioSaude
            :form="form"
            :model="model"
        />
    </rkm-form>
</template>

<script>
// Components.
import CidadaoQuestionarioSaude from '@/components/cadastro/cidadao/QuestionarioSaude'

export default {
    components: { CidadaoQuestionarioSaude },
    props: {
        form: { type: Object, required: true },
        model: { type: Object, required: true },
    },
    methods: {
        validate() {

            return this.$refs.Form.validate()
        },
    }
}
</script>